/**
 * Денежные утилиты для frontend.
 *
 * Backend отдаёт суммы как строки ("123456.78") — ВСЕГДА используем строки,
 * никогда не парсим в Number (потеря точности на больших значениях).
 *
 * Для UI показываем форматированно через Intl.NumberFormat.
 */

const RU_FORMATTER = new Intl.NumberFormat("ru-RU", {
  style: "currency",
  currency: "RUB",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoney(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  // Парсим строку в число ТОЛЬКО для форматирования (не для арифметики)
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (Number.isNaN(num)) return String(value);
  return RU_FORMATTER.format(num);
}

const RU_DATE_FORMATTER = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return String(value);
  return RU_DATE_FORMATTER.format(d);
}

const RU_DATETIME_FORMATTER = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return String(value);
  return RU_DATETIME_FORMATTER.format(d);
}
